export const COUNTRIES_TRANSLATED = {
  en: 'countries',
  de: 'lander',
  es: 'paises',
  fr: 'pays',
  it: 'paesi',
  nl: 'landen',
};
